import AsidePanel from './AsidePanel.vue'

export default AsidePanel
